module.exports = __webpack_public_path__ + "img/edge_divers_office_tourisme.a4ca28f8.svg";